export default __webpack_public_path__ + "static/media/empAddLeave.ddb04910.png";